import { AppStateType } from 'reducers';
import { createSelector } from 'reselect';

export const selectGlobalReducerState = (state: AppStateType) => state.globalReducer;

export const selectIsDevMode = createSelector(selectGlobalReducerState, (state) => state.isDevMode);

export const selectOpenRoutes = createSelector(
  selectGlobalReducerState,
  (state) => state.openRoutes,
);
